import script from "./scanedTeacherAttendence.vue?vue&type=script&setup=true&lang=js"
export * from "./scanedTeacherAttendence.vue?vue&type=script&setup=true&lang=js"

import "./scanedTeacherAttendence.vue?vue&type=style&index=0&id=63bff329&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63bff329"]])

export default __exports__